// Which "See it in your room" a BROWSER gets (the app builds are decided in
// src/lib/see-in-room.js: the native shop, or the system viewer):
//
//   'webxr'      a browser with WebXR immersive-ar (Chrome on Android): the
//                walkable shop in the browser (src/components/WebShop.vue)
//   'quicklook'  iPhone / iPad Safari: the bay in AR Quick Look, with
//                tap-to-lift and the Add-to-bag banner (src/lib/quicklook.js)
//   'preview'    anything else (desktop, Firefox, old phones): the same shop
//                in the page, as a 3D walk-around without the camera
//
// `?xr-emulate` (development only) installs the Immersive Web Emulator first,
// so the WebXR path runs on a desktop browser (src/lib/xr-emulate.js).

let xrSupport = null;

async function emulate () {
  if (!import.meta.env.DEV) return;
  const q = typeof location !== 'undefined' ? new URLSearchParams(location.search) : null;
  if (!q?.has('xr-emulate')) return;
  const { installEmulator } = await import('./xr-emulate.js');
  await installEmulator({ domOverlay: q.get('xr-emulate') !== 'nodom' });
}

/** True where `navigator.xr` can start an immersive-ar session. Cached. */
export function webXRSupported () {
  if (!xrSupport) {
    xrSupport = (async () => {
      await emulate();
      const xr = typeof navigator !== 'undefined' ? navigator.xr : null;
      if (!xr?.isSessionSupported) return false;
      try { return !!(await xr.isSessionSupported('immersive-ar')); } catch { return false; }
    })();
  }
  return xrSupport;
}

/** Safari only treats <a rel="ar"> as AR Quick Look where it can show it. */
export function quickLookSupported () {
  if (typeof document === 'undefined') return false;
  try { return document.createElement('a').relList.supports('ar'); } catch { return false; }
}

/** The route for this browser (see the top of the file). */
export async function arRoute () {
  if (await webXRSupported()) return 'webxr';
  if (quickLookSupported()) return 'quicklook';
  return 'preview';
}
